// extracted by mini-css-extract-plugin
module.exports = {"team":"index-module--team--9QVFb","card":"index-module--card--2Ve5X"};